// i18n dictionary for Italian & English

export const translations = {
  it: {
    // Nav
    'nav.home': 'Home',
    'nav.templates': 'Template',
    'nav.pricing': 'Prezzi',
    'nav.builder': 'Crea il tuo invito',
    'nav.create': 'Crea il tuo',
    'nav.cart': 'Carrello',

    // Home
    'home.eyebrow': 'Inviti digitali · per ogni occasione',
    'home.title1': 'Non un video.',
    'home.title2': 'Un invito che',
    'home.title3': 'si apre',
    'home.subtitle': "Il tuo ospite tocca lo schermo e vive un momento: una scena animata con musica, il suo nome, poi il sito completo dell'evento. Per ogni occasione.",
    'home.cta.create': 'Crea il tuo invito',
    'home.cta.templates': 'Guarda i template',
    'home.chip.ready': 'Pronto in',
    'home.chip.minutes': '2 minuti',
    'home.chip.pay': 'Paghi solo',
    'home.chip.like': 'se ti piace',
    'home.touch.eyebrow': 'Il tocco che fa la differenza',
    'home.touch.title1': "Un'esperienza,",
    'home.touch.title2': 'non un',
    'home.touch.title3': 'messaggio',
    'home.touch.step1.title': 'Tocca',
    'home.touch.step1.desc': "L'ospite riceve un link e tocca lo schermo per aprire.",
    'home.touch.step2.title': 'Si apre',
    'home.touch.step2.desc': 'Parte una scena animata con musica e appare il suo nome.',
    'home.touch.step3.title': 'Si vive',
    'home.touch.step3.desc': 'Poi scorre il sito completo: programma, foto, conferme.',
    'home.how.eyebrow': 'Come funziona',
    'home.how.title1': 'Semplice come',
    'home.how.title2': 'deve essere',
    'home.how.step1.title': "Scegli l'occasione",
    'home.how.step1.desc': 'Nome, data e due dettagli.',
    'home.how.step2.title': 'Lo crei tu in 2 minuti',
    'home.how.step2.desc': 'È già pronto: cambi testi, foto e colori e lo rendi tuo.',
    'home.how.step3.title': 'Lo pubblichi se ti piace',
    'home.how.step3.desc': 'Link immediato da condividere con tutti.',
    'home.how.start': 'Inizia ora',
    'home.features.eyebrow': 'Tutto coordinato',
    'home.features.title1': 'Curato in ogni dettaglio,',
    'home.features.title2': 'e',
    'home.features.title3': 'sotto controllo',
    'home.features.subtitle': "Non solo l'invito: tutto l'evento in un unico link, gestito e ordinato per te.",
    'home.faq.eyebrow': 'Domande frequenti',
    'home.faq.title1': 'Buono a',
    'home.faq.title2': 'sapersi',
    'home.final.title1': 'Un invito che',
    'home.final.title2': 'si apre',
    'home.final.subtitle': 'Per ogni occasione. Indimenticabile.',
    'home.pill1.tocca': 'Tocca',
    'home.pill1.si_apre': 'si apre',

    // Pricing
    'pricing.eyebrow': 'Prezzi trasparenti',
    'pricing.title1': 'Un caffè. E il tuo',
    'pricing.title2': 'invito',
    'pricing.title3': 'è pronto.',
    'pricing.subtitle': 'Prova gratis, paghi solo quando pubblichi. Nessun abbonamento, nessuna sorpresa.',
    'pricing.mostChosen': 'IL PIÙ SCELTO',
    'pricing.oneTime': 'una tantum',
    'pricing.extras.eyebrow': 'Opzioni extra',
    'pricing.extras.title1': 'Personalizza il tuo invito',
    'pricing.extras.title2': 'a piacere',
    'pricing.extras.hint': 'Ogni extra aggiunge solo',
    'pricing.extras.hint2': "Le selezioni si fanno in fase di creazione.",
    'pricing.freeHint': 'Provalo gratis. Paghi solo quando lo metti nel carrello.',

    // Tier taglines
    'tier.base.tagline': 'Il tuo primo invito, essenziale',
    'tier.plus.tagline': 'Il più scelto',
    'tier.complete.tagline': "L'esperienza integrale",

    // Tier features
    'tier.base.f1': 'Busta animata al tocco',
    'tier.base.f2': 'Nome ospite personalizzato',
    'tier.base.f3': 'Data, ora, luogo',
    'tier.base.f4': 'Messaggio di benvenuto',
    'tier.base.f5': 'Link condivisibile',
    'tier.base.f6': 'Si apre su ogni telefono',
    'tier.plus.f1': 'Tutto del piano Base',
    'tier.plus.f2': 'Palette colori personalizzata',
    'tier.plus.f3': 'Musica di sottofondo',
    'tier.plus.f4': 'Galleria foto (fino a 10)',
    'tier.plus.f5': 'Programma della giornata',
    'tier.plus.f6': 'RSVP via WhatsApp',
    'tier.complete.f1': 'Tutto del piano Plus',
    'tier.complete.f2': 'Sfondo con foto personalizzata',
    'tier.complete.f3': 'Galleria foto illimitata',
    'tier.complete.f4': 'Modifiche in tempo reale',
    'tier.complete.f5': 'Dashboard conferme',
    'tier.complete.f6': 'Assistenza prioritaria',

    // Extras labels
    'ex1.label': 'Musica di sottofondo custom (upload)',
    'ex2.label': 'Sfondo con foto personalizzata',
    'ex3.label': "Countdown all'evento",
    'ex4.label': 'Mappa interattiva del luogo',
    'ex5.label': 'Galleria foto extra (10+)',
    'ex6.label': 'RSVP via WhatsApp',
    'ex8.label': 'Video di benvenuto (upload)',
    'ex9.label': 'Menu della cena',
    'ex10.label': 'Dress code & tema',
    'ex11.label': 'Lista regali / registry',
    'ex12.label': 'QR code stampabile',

    // Builder
    'builder.eyebrow': 'Configuratore live',
    'builder.title1': 'Crea il tuo',
    'builder.title2': 'invito',
    'builder.subtitle': "Ogni modifica appare subito nel telefono a destra, già animato.",
    'builder.step.tier': 'Scegli il tipo di invito',
    'builder.step.tier.hint': 'Determina le funzionalità disponibili',
    'builder.step.template': 'Scegli il template',
    'builder.step.details': 'Dettagli evento',
    'builder.step.style': 'Stile',
    'builder.step.music': 'Musica di sottofondo',
    'builder.step.whatsapp': 'Conferma presenza via WhatsApp',
    'builder.step.gallery': 'Galleria foto',
    'builder.step.photo': 'Foto di sfondo personalizzata',
    'builder.step.program': 'Programma della giornata',
    'builder.step.extras': 'Opzioni aggiuntive',
    'builder.step.extras.hint': "€0,50 l'una",
    'builder.field.celebrant': 'Nome del festeggiato',
    'builder.field.age': 'Età / occasione',
    'builder.field.event': 'Nome evento',
    'builder.field.date': 'Data',
    'builder.field.time': 'Ora',
    'builder.field.location': 'Luogo',
    'builder.field.message': 'Messaggio di benvenuto',
    'builder.field.dress': 'Dress code (facoltativo)',
    'builder.field.whatsapp': 'Numero WhatsApp',
    'builder.field.photoHint': 'Carica una foto per personalizzare lo sfondo.',
    'builder.font.elegant': 'Elegante',
    'builder.font.modern': 'Moderno',
    'builder.summary.title': 'Il tuo invito è pronto?',
    'builder.summary.subtitle': 'Riepilogo e aggiungi al carrello.',
    'builder.summary.plan': 'Piano',
    'builder.summary.extras': 'Extra',
    'builder.summary.total': 'Totale',
    'builder.save': 'Salva & metti nel carrello',
    'builder.saving': 'Salvando…',
    'builder.preview.live': 'Anteprima dal vivo',

    // Music picker
    'music.trending': 'Trend del momento',
    'music.search': 'Cerca titolo, artista o genere…',
    'music.selected': 'Scelta',
    'music.select': 'Seleziona',
    'music.tab.tiktok': 'TikTok Viral',
    'music.tab.library': 'Le nostre tracce',
    'music.noPreview': 'Anteprima non disponibile',
    'music.empty': 'Nessun brano trovato.',
    'music.hint': 'Preview di 30 secondi · trend aggiornati in tempo reale.',

    // Cart
    'cart.eyebrow': 'Il tuo carrello',
    'cart.title1': 'Rivedi e',
    'cart.title2': 'paga',
    'cart.back': 'Torna al configuratore',
    'cart.empty.title1': 'Il carrello è',
    'cart.empty.title2': 'vuoto',
    'cart.empty.subtitle': 'Crea il tuo primo invito e aggiungilo qui.',
    'cart.empty.cta': 'Crea un invito',
    'cart.paid.title1': 'Pagamento',
    'cart.paid.title2': 'completato',
    'cart.paid.subtitle': 'Il tuo invito è stato pubblicato. Ecco il link per scaricarlo e condividerlo:',
    'cart.paid.copy': 'Copia',
    'cart.paid.open': 'Apri',
    'cart.paid.another': 'Crea un altro invito →',
    'cart.summary': 'Riepilogo & pagamento',
    'cart.total': 'Totale',
    'cart.payHint': 'Paga in modo sicuro con',
    'cart.secure': 'PAGAMENTO SICURO · SSL',
    'cart.preview.title': 'Anteprima invito',

    // Common
    'common.remove': 'Rimuovi',
    'common.continue': 'Continua',
    'common.back': 'Indietro',
    'common.language': 'Lingua',
    'common.currency': 'Valuta',
  },
  en: {
    'nav.home': 'Home',
    'nav.templates': 'Templates',
    'nav.pricing': 'Pricing',
    'nav.builder': 'Create your invite',
    'nav.create': 'Create yours',
    'nav.cart': 'Cart',

    'home.eyebrow': 'Digital invitations · for every occasion',
    'home.title1': 'Not a video.',
    'home.title2': 'An invitation that',
    'home.title3': 'opens',
    'home.subtitle': "Your guest taps the screen and lives a moment: an animated scene with music, their name, then the full event site. For every occasion.",
    'home.cta.create': 'Create your invite',
    'home.cta.templates': 'Browse templates',
    'home.chip.ready': 'Ready in',
    'home.chip.minutes': '2 minutes',
    'home.chip.pay': 'Pay only',
    'home.chip.like': "if you like it",
    'home.touch.eyebrow': 'The touch that makes the difference',
    'home.touch.title1': 'An experience,',
    'home.touch.title2': 'not a',
    'home.touch.title3': 'message',
    'home.touch.step1.title': 'Tap',
    'home.touch.step1.desc': 'Your guest gets a link and taps the screen to open.',
    'home.touch.step2.title': 'It opens',
    'home.touch.step2.desc': 'An animated scene with music starts and their name appears.',
    'home.touch.step3.title': 'It lives',
    'home.touch.step3.desc': 'Then the full site: schedule, photos, RSVPs.',
    'home.how.eyebrow': 'How it works',
    'home.how.title1': 'Simple as',
    'home.how.title2': 'it should be',
    'home.how.step1.title': 'Choose the occasion',
    'home.how.step1.desc': 'Name, date, two details.',
    'home.how.step2.title': 'Build it in 2 minutes',
    'home.how.step2.desc': "It's ready: change texts, photos, colors, make it yours.",
    'home.how.step3.title': 'Publish if you like it',
    'home.how.step3.desc': 'Instant link to share with everyone.',
    'home.how.start': 'Start now',
    'home.features.eyebrow': 'All coordinated',
    'home.features.title1': 'Every detail cared for,',
    'home.features.title2': 'and',
    'home.features.title3': 'under control',
    'home.features.subtitle': 'Not just the invite: the whole event in one link, managed and organized for you.',
    'home.faq.eyebrow': 'Frequently asked',
    'home.faq.title1': 'Good to',
    'home.faq.title2': 'know',
    'home.final.title1': 'An invitation that',
    'home.final.title2': 'opens',
    'home.final.subtitle': 'For every occasion. Unforgettable.',
    'home.pill1.tocca': 'Tap',
    'home.pill1.si_apre': 'it opens',

    'pricing.eyebrow': 'Transparent pricing',
    'pricing.title1': 'A coffee. And your',
    'pricing.title2': 'invite',
    'pricing.title3': 'is ready.',
    'pricing.subtitle': 'Try for free, pay only when you publish. No subscription, no surprises.',
    'pricing.mostChosen': 'MOST CHOSEN',
    'pricing.oneTime': 'one-time',
    'pricing.extras.eyebrow': 'Extra options',
    'pricing.extras.title1': 'Customize your invite',
    'pricing.extras.title2': 'as you like',
    'pricing.extras.hint': 'Each extra adds only',
    'pricing.extras.hint2': 'Selections happen during creation.',
    'pricing.freeHint': 'Try free. Pay only when you add to cart.',

    'tier.base.tagline': 'Your first invite, essential',
    'tier.plus.tagline': 'Most popular',
    'tier.complete.tagline': 'The full experience',

    'tier.base.f1': 'Envelope animation on tap',
    'tier.base.f2': 'Personalized guest name',
    'tier.base.f3': 'Date, time, location',
    'tier.base.f4': 'Welcome message',
    'tier.base.f5': 'Shareable link',
    'tier.base.f6': 'Opens on any phone',
    'tier.plus.f1': 'Everything in Base',
    'tier.plus.f2': 'Custom color palette',
    'tier.plus.f3': 'Background music',
    'tier.plus.f4': 'Photo gallery (up to 10)',
    'tier.plus.f5': "Day's schedule",
    'tier.plus.f6': 'RSVP via WhatsApp',
    'tier.complete.f1': 'Everything in Plus',
    'tier.complete.f2': 'Custom background photo',
    'tier.complete.f3': 'Unlimited photo gallery',
    'tier.complete.f4': 'Real-time edits',
    'tier.complete.f5': 'RSVP dashboard',
    'tier.complete.f6': 'Priority support',

    'ex1.label': 'Custom background music (upload)',
    'ex2.label': 'Custom background photo',
    'ex3.label': 'Event countdown',
    'ex4.label': 'Interactive location map',
    'ex5.label': 'Extra photo gallery (10+)',
    'ex6.label': 'RSVP via WhatsApp',
    'ex8.label': 'Welcome video (upload)',
    'ex9.label': 'Dinner menu',
    'ex10.label': 'Dress code & theme',
    'ex11.label': 'Gift registry',
    'ex12.label': 'Printable QR code',

    'builder.eyebrow': 'Live configurator',
    'builder.title1': 'Create your',
    'builder.title2': 'invite',
    'builder.subtitle': 'Every change appears in the phone on the right, already animated.',
    'builder.step.tier': 'Choose your plan',
    'builder.step.tier.hint': 'Determines which features are available',
    'builder.step.template': 'Choose a template',
    'builder.step.details': 'Event details',
    'builder.step.style': 'Style',
    'builder.step.music': 'Background music',
    'builder.step.whatsapp': 'RSVP via WhatsApp',
    'builder.step.gallery': 'Photo gallery',
    'builder.step.photo': 'Custom background photo',
    'builder.step.program': "Day's schedule",
    'builder.step.extras': 'Extra options',
    'builder.step.extras.hint': '€0.50 each',
    'builder.field.celebrant': "Guest of honor's name",
    'builder.field.age': 'Age / occasion',
    'builder.field.event': 'Event name',
    'builder.field.date': 'Date',
    'builder.field.time': 'Time',
    'builder.field.location': 'Location',
    'builder.field.message': 'Welcome message',
    'builder.field.dress': 'Dress code (optional)',
    'builder.field.whatsapp': 'WhatsApp number',
    'builder.field.photoHint': 'Upload a photo to customize the background.',
    'builder.font.elegant': 'Elegant',
    'builder.font.modern': 'Modern',
    'builder.summary.title': 'Ready to publish?',
    'builder.summary.subtitle': 'Review and add to cart.',
    'builder.summary.plan': 'Plan',
    'builder.summary.extras': 'Extras',
    'builder.summary.total': 'Total',
    'builder.save': 'Save & add to cart',
    'builder.saving': 'Saving…',
    'builder.preview.live': 'Live preview',

    'music.trending': 'Trending now',
    'music.search': 'Search title, artist or genre…',
    'music.selected': 'Selected',
    'music.select': 'Select',
    'music.tab.tiktok': 'TikTok Viral',
    'music.tab.library': 'Our tracks',
    'music.noPreview': 'Preview not available',
    'music.empty': 'No tracks found.',
    'music.hint': '30-second previews · trends updated live.',

    'cart.eyebrow': 'Your cart',
    'cart.title1': 'Review and',
    'cart.title2': 'pay',
    'cart.back': 'Back to configurator',
    'cart.empty.title1': 'Cart is',
    'cart.empty.title2': 'empty',
    'cart.empty.subtitle': 'Create your first invite and add it here.',
    'cart.empty.cta': 'Create an invite',
    'cart.paid.title1': 'Payment',
    'cart.paid.title2': 'completed',
    'cart.paid.subtitle': 'Your invite is published. Here is the link to download and share:',
    'cart.paid.copy': 'Copy',
    'cart.paid.open': 'Open',
    'cart.paid.another': 'Create another invite →',
    'cart.summary': 'Summary & payment',
    'cart.total': 'Total',
    'cart.payHint': 'Pay securely with',
    'cart.secure': 'SECURE PAYMENT · SSL',
    'cart.preview.title': 'Invite preview',

    'common.remove': 'Remove',
    'common.continue': 'Continue',
    'common.back': 'Back',
    'common.language': 'Language',
    'common.currency': 'Currency',
  },
};

// Exchange rate (rough - EUR to USD). Fixed for MVP.
export const FX_EUR_USD = 1.08;

export const formatPrice = (amountEur, currency = 'EUR', lang = 'it') => {
  const value = currency === 'USD' ? amountEur * FX_EUR_USD : amountEur;
  const symbol = currency === 'USD' ? '$' : '€';
  const formatted = value.toFixed(2);
  return `${symbol}${formatted}`;
};
